export enum SelectType {
  Radio = 'radio',
  RadioImg = 'radioimg',
  Multiple = 'multiple',
  Autocomplete = 'autocomplete',
}
